import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { _axios } from 'src/plugins/axios';
import commonService from 'src/service/common';
import SearchByEmployeeDetailsNav from '../shared/SearchByEmployeeDetailsNav';
import ShowHistory from '../shared/ShowHistory';
import ShowOrders from '../shared/ShowOrders';
import config from '../../../config/constants.json';
import moment from 'moment';

class TrackOrder extends Component {
    constructor() {
        super();
        this.state = {
            searchBarPlaceholders: ['Enter Employee Id', 'Enter Phone Number'],
            menuItemList: [
                {
                    value: "employeeId",
                    placeholder: "Employee ID"
                },
                {
                    value: "phoneNumber",
                    placeholder: "Phone Number"
                },
            ],
            orderDetails: [],
            orderCount: null,
            orderHistory: null,
            selectedHistoryOfItem: {},
            searchType: null,
            page: 1,
            isNextPageAvailable: false,
            entityId: null
        }
    }

    componentDidMount = () => {
        let entityId = commonService.getEntityID();
        this.setState({
            entityId: entityId
        })
    }

    handleSubmit = async (searchType, pageNumber = 1) => {
        this.setState({ orderDetails: [], orderCount: null, isNextPageAvailable: false })
        const searchedValue = document.getElementById("mto-search")?.value;
        if (!searchedValue) {
            alert("Enter Employee details")
            return;
        }

        const employeeId = searchType == this.state.searchBarPlaceholders[0] ? searchedValue : null;
        const phoneNumber = searchType == this.state.searchBarPlaceholders[1] ? searchedValue : null;
        const fromDate = config.SBIGroupEntityIds.includes(this.state.entityId) ? config.FromDateCheckForSBIOrders : null;

        const payload = {
            employeeId: employeeId,
            phoneNumber: phoneNumber,
            serviceType: 'meds',
            pageNumber: pageNumber,
            fromDate: fromDate
        }

        _axios.post('mini-procheck/orderDetails', payload, {
            ignoreLoading: false,
            headers: {
                authtoken: commonService.getAuthToken(),
                'Content-Type': 'application/json'
            }
        }).then((response) => {
            if (response?.data?.isSuccess) {
                this.setState({
                    orderDetails: response.data?.orderDetails,
                    orderCount: response.data?.totalRequest,
                    searchType: searchType,
                    page: pageNumber,
                    isNextPageAvailable: response.data?.isNextPageAvailable
                })

                if (response?.data?.orderDetails?.length == 0)
                    alert("No active records found");
            }
        }).catch((error) => {
            error?.response?.data?.message ? alert(error.response.data.message) : alert("Internal Server Error");
        });
    }

    handlePageChanged = async (event, value) => {
        await this.handleSubmit(this.state.searchType, value);
        return;
    }

    handleViewHistory = async (appointment) => {
        this.setState({
            orderHistory: null,
            selectedHistoryOfItem: {}
        })
        if (!appointment?.requestID) {
            alert("Request ID not found");
            return;
        }

        const payload = {
            requestId: appointment.requestID
        }

        _axios.post('mini-procheck/orderHistory', payload, {
            ignoreLoading: false,
            headers: {
                authtoken: commonService.getAuthToken(),
                'Content-Type': 'application/json'
            }
        }).then((response) => {
            if (response?.data?.isSuccess) {
                this.setState({
                    orderHistory: response.data?.history,
                    selectedHistoryOfItem: {
                        orderPlaced: appointment.orderPlaced,
                        orderId: appointment.requestID,
                        phoneNumber: appointment.phoneNumber,
                        orderPlacedFor: appointment.name
                    }
                })
            }
        }).catch((err) => {
            err?.response?.data?.message ? alert(err.response.data.message) : "Internal Server Error";
        })
    }

    handleHideHistorySection = () => {
        this.setState({ orderHistory: null, selectedHistoryOfItem: {} });
        return;
    }

    render() {
        return (
            <>
                <Helmet>
                    <title>Medicine | Track Orders</title>
                </Helmet>

                <SearchByEmployeeDetailsNav
                    searchBarPlaceholders={this.state.searchBarPlaceholders}
                    menuItemList={this.state.menuItemList}
                    handleSubmit={(searchType) => this.handleSubmit(searchType)}
                />

                {
                    config.SBIGroupEntityIds.includes(this.state.entityId) && config.FromDateCheckForSBIOrders ?
                        <span className='to-noteContainer'>
                            <span className='to-noteHeader'>Note: </span>
                            <span className='to-noteBody'>Only orders placed from {moment(config.FromDateCheckForSBIOrders).format('DD MMM YYYY')}</span>
                        </span> :
                        null
                }

                {
                    !this.state.orderHistory ?
                        (this.state.orderDetails.length > 0 ?
                            <ShowOrders
                                appointments={this.state.orderDetails}
                                orderCount={this.state.orderCount}
                                handleViewHistory={(requestID) => this.handleViewHistory(requestID)}
                                handlePageChanged={(event, page) => this.handlePageChanged(event, page)}
                                page={this.state.page}
                                isNextPageAvailable={this.state.isNextPageAvailable}
                            /> : null) :
                        <ShowHistory
                            orderHistory={this.state.orderHistory}
                            handleHideHistorySection={() => this.handleHideHistorySection()}
                            appointment={this.state.selectedHistoryOfItem}
                        />
                }
            </>
        )

    }
}

export default TrackOrder;